export enum TipoPerfilDeAcesso {

  OWNER = 'OWNER',
  CLIENT = 'CLIENT'

}